function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "@churchofjesuschrist/eden-platform-modal";
const ContentWrappper = styled.div.withConfig({
  componentId: "sc-1aym6or-0"
})(["width:100vw;@media (min-width:25rem){width:50vw;max-width:550px;min-width:25rem;}"]);

const ToolModal = _ref => {
  let {
    active,
    onCloseGesture,
    children,
    heading,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Modal, _extends({
    active: active,
    onCloseGesture: onCloseGesture,
    heading: heading
  }, rest), /*#__PURE__*/React.createElement(ContentWrappper, null, children));
};

ToolModal.propTypes = {
  /** Modal content */
  children: PropTypes.node.isRequired,

  /** Whether modal is open */
  active: PropTypes.bool,

  /** Callback to execute when the modal closes */
  onCloseGesture: PropTypes.func,

  /** A string to display in the heading slot */
  heading: PropTypes.string
};
export default ToolModal;